import React from "react";
import StockTanksNav from "./../components/elements/stocktanksnav.jsx"
import backgroundImage1 from "./../assets/img/stocktanks.webp";
import backgroundImage2 from "./../assets/img/accessoires.webp";

const sections = [
    {
      title: "TANKKD",
      desc:"Tous nos packs",
      buttonLabel: "DÉCOUVRIR",
      buttonLink: "/tankkd",
      imageUrl: backgroundImage1,
    },
    {
      title: "ACCESSOIRES",
      desc:"Tous pour votre mini-piscine",
      buttonLabel: "DÉCOUVRIR",
      buttonLink: "/accessoires",
      imageUrl: backgroundImage2,
    },
];  

const StockTanks = () => {

  return (
    <div className="grid grid-cols-1 xl:grid-cols-2">
      {sections.map((section, index) => (
        <StockTanksNav
        key={index}
        title={section.title}
        desc={section.desc}
        buttonLabel={section.buttonLabel}
        buttonLink={section.buttonLink}
        imageUrl={section.imageUrl}
        />
      ))}
    </div>
  );
}

export default StockTanks;